export const DRIVER_ADD_REQUEST = "DRIVER_ADD_REQUEST";
export const DRIVER_ADD_SUCCESS = "DRIVER_ADD_SUCCESS";
export const DRIVER_ADD_FAIL = "DRIVER_ADD_FAIL";

export const DRIVER_DETAIL_REQUEST = "DRIVER_DETAIL_REQUEST";
export const DRIVER_DETAIL_SUCCESS = "DRIVER_DETAIL_SUCCESS";
export const DRIVER_DETAIL_FAIL = "DRIVER_DETAIL_FAIL";

export const DRIVER_UPDATE_REQUEST = "DRIVER_UPDATE_REQUEST";
export const DRIVER_UPDATE_SUCCESS = "DRIVER_UPDATE_SUCCESS";
export const DRIVER_UPDATE_FAIL = "DRIVER_UPDATE_FAIL";

export const DRIVER_DELETE_REQUEST = "DRIVER_DELETE_REQUEST";
export const DRIVER_DELETE_SUCCESS = "DRIVER_DELETE_SUCCESS";
export const DRIVER_DELETE_FAIL = "DRIVER_DELETE_FAIL";

export const DRIVER_LIST_REQUEST = "DRIVER_LIST_REQUEST";
export const DRIVER_LIST_SUCCESS = "DRIVER_LIST_SUCCESS";
export const DRIVER_LIST_FAIL = "DRIVER_LIST_FAIL";
